import { BudgetStatusEnum } from "../../enums/budgetStatus";

export const getStatusColor = (status: string) => {
  switch (status) {
    case BudgetStatusEnum.PENDING:
    case "Pendente":
      return "bg-gray text-gray-600 font-bold";
    case BudgetStatusEnum.APPROVED:
    case "Aprovado":
      return "bg-green-500 text-white font-bold";
    case BudgetStatusEnum.REJECTED:
    case "Recusado":
      return "bg-red-500 text-white font-bold";
    case BudgetStatusEnum.CHANGED:
    case BudgetStatusEnum.COUNTER_PROPOSAL:
    case "Alterado":
    case "Contraproposta":
      return "bg-orange-500 text-white font-bold";
    default:
      return "bg-gray text-gray-600 font-bold";
  }
};

export const isStatusWithBadge = (status: string): boolean => {
  const validStatuses = [
    BudgetStatusEnum.PENDING,
    BudgetStatusEnum.CHANGED,
    BudgetStatusEnum.COUNTER_PROPOSAL,
    BudgetStatusEnum.REJECTED,
    BudgetStatusEnum.APPROVED,
    "Pendente",
    "Alterado",
    "Contraproposta",
    "Recusado",
    "Aprovado",
  ];
  return validStatuses.includes(status);
};

export const isHistoryStatusWithBadge = (status: string): boolean => {
  const validHistoryStatuses = [
    BudgetStatusEnum.CHANGED,
    BudgetStatusEnum.COUNTER_PROPOSAL,
    BudgetStatusEnum.REJECTED,
    BudgetStatusEnum.APPROVED,
    "Alterado",
    "Contraproposta",
    "Recusado",
    "Aprovado",
  ];
  return validHistoryStatuses.includes(status);
};

export const formatRecipientLabel = (recipient: string): string => {
  const normalized = recipient?.toUpperCase().trim();
  switch (normalized) {
    case "CONSULTANT":
      return "Consultor da Concessionária";
    case "FACTORY":
    case "TOWER":
      return "Volks|total";
    case "MANAGER":
      return "Gestor de Frotas";
    default:
      return recipient || "";
  }
};

export const replaceUrlPersona = (url: string, persona?: string): string | undefined => {
  const urlObj = new URL(url);
  const pathParts = urlObj.pathname.split('/').filter(part => part !== '');
  
  if (pathParts.length === 0) {
    return url;
  }

  pathParts[0] = persona || pathParts[0];
  urlObj.pathname = '/' + pathParts.join('/');
  
  return urlObj.toString();
};
